import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiRequest from '../../api/request';

const initialState = {
  refundrequests: {},
  loading: false,
  submitionLoading: false,
  stundentslist: [],
  projectslist: [{ id: 0, name: 'All' }],
  crolist: [],
  allcourses: [],
  subjects: [],
  studentData: {},
  leadData: {},
  refundCalculation: {},
  refundTutorsTable: {
    loading: false,
    data: [],
  },
  refundRequestTable: {
    data: [],
    meta: {},
  },
  refundApprovalsData: {
    data: [],
    meta: {},
  },
  refundRequestPmData: {
    data: [],
    meta: {},
  },
  scheduledPayments: {
    data: [],
    meta: {},
  },
  deductionTable: {
    data: [],
    meta: {},
  },
  refundTrack: [],

  topsectionDashboard: {
    data: {},
    topsectionDashboardLoading: false,
  },
  secondCardCounts: {
    data: {},
    secondCardCountsLoading: false,
  },
  refundProjectTable: {
    data: [],
    projectTableLoading: false,
  },
  refundOverviewTable: {
    data: [],
    refundOverviewLoading: false,
  },
  croAndOgaRefundList: {
    cro: [],
    oga: [],
    croAndOgaLoading: false,
  },
  refundRoleWiseTable: {
    data: [],
    refundRoleWiseLoading: false,
    meta: {},
  },
  duplicateRefundRequestFinance: {
    data: [],
    meta: {},
    duplicateRefundRequestFinanceLoading: false,
  },
  additionalLoading: false,
  rerequestRaisedCount: {
    data: [],
    meta: {},
  },
  pmPendingCount: JSON.parse(localStorage.getItem('refundPendingCounts'))?.PM || 0,
};

export const getAddedRequests = createAsyncThunk('refund/getAddedRequests', async (data) => {
  const res = await apiRequest({
    method: 'get',
    url: `refund-requests?page=${data.page}&limit=${data.limit}&search=${data.search}`,
  });
  return res;
});

export const addRefundRequest = createAsyncThunk('refund/addRefundRequest', async (data) => {
  const res = await apiRequest({
    method: 'post',
    url: `/refund-management/create-refund-request`,
    data: data,
  });
  return res;
});

export const getStudents = createAsyncThunk('refund/getStudents', async ({ search = '', page = 1, limit = 50 }) => {
  const res = await apiRequest({
    method: 'get',
    url: `refund-management/get-student-list?search=${search}&page=${page}&limit=${limit}`,
  });
  return res;
});

export const getLeadListForOtherIncome = createAsyncThunk(
  'refund/getLeadListForOtherIncome',
  async ({ search = '', page = 1, limit = 50 }) => {
    const res = await apiRequest({
      url: `/refund-management/get-non-enrolled-lead-list?search=${search}&page=${page}&limit=${limit}`,
      method: 'get',
    });
    return res;
  },
);

export const getProjects = createAsyncThunk('refund/getProjects', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `cr-pre-data/getProjects`,
  });
  return res;
});

export const getAllCroList = createAsyncThunk('refund/getAllCroList', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `admission-register/get-all-cro-list`,
  });
  return res;
});

export const getCoursesUndeAdmnNo = createAsyncThunk('refund/getAllActiveCourses', async (admn_no) => {
  const res = await apiRequest({
    method: 'get',
    url: `/refund-management/get-course-list?admn_no=${admn_no}`,
  });
  //
  return res;
});

export const getCoursesUnderLeadId = createAsyncThunk('refund/getCoursesUnderLeadId', async (lead_id) => {
  const res = await apiRequest({
    method: 'get',
    url: `/refund-management/get-courses-under-lead/${lead_id}`,
  });
  //
  return res;
});

export const getSubjectUnderCourseEnrolmentid = createAsyncThunk(
  'refund/getSubjectUnderCourseEnrolmentid',
  async (course_enrollment_id) => {
    const res = await apiRequest({
      url: `/refund-management/get-subject-list?course_enrollment_id=${course_enrollment_id}`,
      method: 'get',
    });
    return res;
  },
);

export const getStudentDetails = createAsyncThunk(
  'refund/getStudentDetails',
  async ({ subject_enrollment_id, course_enrollment_id }) => {
    const res = await apiRequest({
      url: `/refund-management/get-enrolled-course-details?subject_enrollment_id=${subject_enrollment_id}&course_enrollment_id=${course_enrollment_id}`,
      method: 'get',
    });
    return res;
  },
);

export const getLeadDetails = createAsyncThunk('refund/getLeadDetails', async (cart_items_id) => {
  const res = await apiRequest({
    url: `/refund-management/get-lead-details?cart_items_id=${cart_items_id}`,
    method: 'get',
  });
  return res;
});

export const getRefundCalculation = createAsyncThunk(
  'refund/getRefundCalculation',
  async ({ course_enrollment_id, subject_enrollment_id, refund_request_date }) => {
    const res = await apiRequest({
      url: `/refund-management/calculate-refund-amount?subject_enrollment_id=${subject_enrollment_id}&course_enrollment_id=${course_enrollment_id}&refund_request_date=${refund_request_date}`,
      method: 'get',
    });
    return res;
  },
);

//------------------------------------- Refund Request

//Enrolled

export const getEnrolledRefundRequest = createAsyncThunk(
  'finance/getEnrolledRefundRequest',
  async ({ pageNum = 1, gridSize = 10, search = '', status = '', fromDate = '', toDate = '' }) => {
    const searchParams = new URLSearchParams({
      page: pageNum,
      limit: gridSize,
      search,
      status,
      fromDate,
      toDate,
    });
    const res = await apiRequest({
      method: 'get',
      url: `refund-management/get-created-requests?${searchParams.toString()}`,
    });

    return res;
  },
);

//Finance
export const getEnrolledRefundRequestFinance = createAsyncThunk(
  'finance/getEnrolledRefundRequestFinance',
  async (params) => {
    const searchParams = new URLSearchParams({
      ...params,
      ...(params?.statusBy !== undefined && params?.statusType !== undefined && { statusBy: params?.statusBy }),
      ...(params?.statusType !== undefined && params?.statusBy !== undefined && { statusType: params?.statusType }),
    });
    const res = await apiRequest({
      method: 'get',
      url: `refund-management/get-requests-for-finance?${searchParams.toString()}`,
    });

    return res;
  },
);

// export const getEnrolledRefundRequestFinance = createAsyncThunk(
//   'finance/getEnrolledRefundRequestFinance',
//   async (params) => {
//     const searchParams = new URLSearchParams();

//     Object.entries(params).forEach(([key, value]) => {
//       if (value !== undefined && value !== null && value !== '') {
//         searchParams.append(key, value);
//       }
//     });

//     const res = await apiRequest({
//       method: 'get',
//       url: `refund-management/get-requests-for-finance?${searchParams.toString()}`,
//     });

//     return res;
//   },
// );

//Non

export const getNonEnrolledRefundRequest = createAsyncThunk('finance/getNonEnrolledRefundRequest', async (params) => {
  const searchParams = new URLSearchParams(params);
  const res = await apiRequest({
    method: 'get',
    url: `refund-management/get-non-enrolled-refund-requests?${searchParams.toString()}`,
  });

  return res;
});

export const getSchedulePaymentsForNonEnrolledStudents = createAsyncThunk(
  'finance/getSchedulePaymentsForNonEnrolledStudents',
  async ({ pageNum = 1, gridSize = 10, search = '', status = '', fromDate = '', toDate = '', type }) => {
    const searchParams = new URLSearchParams({
      page: pageNum,
      limit: gridSize,
      search,
      status,
      fromDate,
      toDate,
      type,
    });
    const res = await apiRequest({
      method: 'get',
      url: `refund-management/get-scheduled-requests-for-finance-non-enrolled-students?${searchParams.toString()}`,
    });

    return res;
  },
);

export const getSchedulePaymentsForEnrolledStudents = createAsyncThunk(
  'finance/getSchedulePaymentsForEnrolledStudents',
  async ({ pageNum = 1, gridSize = 10, search = '', status = '', fromDate = '', toDate = '' }) => {
    const searchParams = new URLSearchParams({
      page: pageNum,
      limit: gridSize,
      search,
      status,
      fromDate,
      toDate,
    });
    const res = await apiRequest({
      method: 'get',
      url: `refund-management/get-scheduled-requests-for-finance-enrolled-students?${searchParams.toString()}`,
    });

    return res;
  },
);

export const getTutorsTable = createAsyncThunk(
  'finance/getTutorsTable',
  async ({ course_enrollment_id = '', subject_enrollment_id = '' }) => {
    const searchParams = new URLSearchParams({
      course_enrollment_id,
      subject_enrollment_id,
    });
    const res = await apiRequest({
      method: 'get',
      url: `refund-management/get-tutor-list?${searchParams.toString()}`,
    });

    return res;
  },
);

export const getApprovalRequests = createAsyncThunk(
  'refund/getApprovalRequests',
  async ({ pageNum = 1, gridSize = 10, search = '', status = '', fromDate = '', toDate = '' }) => {
    const searchParams = new URLSearchParams({
      page: pageNum,
      limit: gridSize,
      search,
      status,
      fromDate,
      toDate,
    });
    const res = await apiRequest({
      method: 'get',
      url: `refund-management/get-approval-request?${searchParams.toString()}`,
    });

    return res;
  },
);

export const getPmRefundRequests = createAsyncThunk('refund/getPmRefundRequests', async (params) => {
  const searchParams = new URLSearchParams(params);
  const res = await apiRequest({
    method: 'get',
    url: `refund-management/get-requests-for-pm?${searchParams.toString()}`,
  });

  return res;
});

export const getVerificationRequests = createAsyncThunk(
  'refund/getVerificationRequests',
  async ({ pageNum = 1, gridSize = 10, search = '', status = '', fromDate = '', toDate = '' }) => {
    const searchParams = new URLSearchParams({
      page: pageNum,
      limit: gridSize,
      search,
      status,
      fromDate,
      toDate,
    });
    const res = await apiRequest({
      method: 'get',
      url: `refund-management/get-verification-request?${searchParams.toString()}`,
    });
    return res;
  },
);

export const postChangeStatus = createAsyncThunk('refund/postChangeStatus', async (data) => {
  const res = await apiRequest({
    method: 'post',
    url: `refund-management/change-status`,
    data,
  });
  return res;
});

export const postEnrolledScheduleDateFinance = createAsyncThunk(
  'refund/postEnrolledScheduleDateFinance',
  async (data) => {
    const res = await apiRequest({
      method: 'post',
      url: `refund-management/schedule-date-by-finance`,
      data,
    });
    return res;
  },
);

export const postNonEnrolledScheduleDateFinance = createAsyncThunk(
  'refund/postNonEnrolledScheduleDateFinance',
  async (data) => {
    const res = await apiRequest({
      method: 'post',
      url: `refund-management/schedule-date-by-finance-non-enrolled`,
      data,
    });
    return res;
  },
);

export const putBankDetails = createAsyncThunk('refund/putBankDetails', async (data) => {
  const res = await apiRequest({
    method: 'put',
    url: `refund-management/edit-bank-details`,
    data,
  });
  return res;
});

export const deleteRequest = createAsyncThunk('refund/deleteRequest', async ({ holdamount_refund_id, expense_id }) => {
  const searchParams = new URLSearchParams(
    expense_id
      ? {
          expense_id,
        }
      : { holdamount_refund_id },
  );
  const res = await apiRequest({
    method: 'delete',
    url: `refund-management/delete-refund-request?${searchParams}`,
  });
  return res;
});
export const postMarkAsPaid = createAsyncThunk('refund/postMarkAsPaid', async ({ non, data }) => {
  const res = await apiRequest({
    method: 'post',
    url: `refund-management/mark-as-paid-by-finance${non ? '-non-enrolled' : ''}`,
    data,
  });
  return res;
});

export const updateTransactionDate = createAsyncThunk('refund/updateTransactionDate', async (data) => {
  const res = await apiRequest({
    method: 'put',
    url: `refund-management/update-transaction-date`,
    data,
  });
  return res;
});

export const getDeductionTableForEnrollment = createAsyncThunk(
  'finance/getDeductionTableForEnrollment',
  async ({ pageNum = 1, gridSize = 10, search = '', project, fromDate = '', toDate = '' }) => {
    const searchParams = new URLSearchParams({
      page: pageNum,
      limit: gridSize,
      search,
      project_id: project,
      from_date: fromDate,
      to_date: toDate,
    });
    const res = await apiRequest({
      method: 'get',
      url: `refund-management/get-refund-deduction-datas-for-enrolled-students?${searchParams.toString()}`,
    });

    return res;
  },
);
export const getDeductionTableForNonEnrollment = createAsyncThunk(
  'finance/getDeductionTableForNonEnrollment',
  async ({ pageNum = 1, gridSize = 10, search = '', project, fromDate = '', toDate = '' }) => {
    const searchParams = new URLSearchParams({
      page: pageNum,
      limit: gridSize,
      search,
      project_id: project,
      from_date: fromDate,
      to_date: toDate,
    });
    const res = await apiRequest({
      method: 'get',
      url: `refund-management/get-refund-deduction-datas-for-non-enrolled-students?${searchParams.toString()}`,
    });

    return res;
  },
);

export const getRefundTrack = createAsyncThunk('finance/getRefundTrack', async (refundId) => {
  const res = await apiRequest({
    method: 'get',
    url: `refund-management/get-tracking-data/${refundId}`,
  });

  return res;
});
export const topCardCounts = createAsyncThunk('refund/topCardCounts', async (dispatchParams) => {
  const searchParams = new URLSearchParams({
    fromDate: dispatchParams?.fromDate ?? '',
    toDate: dispatchParams?.toDate ?? '',
    project_id: dispatchParams?.projectId ?? '',
    type: Number(dispatchParams?.type) + 1 ?? '',
  });
  const res = await apiRequest({
    method: 'get',
    url: `refund-management/get-finance-count-card-data?${searchParams.toString()}`,
  });
  return res;
});

export const secondCardCounts = createAsyncThunk('refund/secondCardCounts', async (dispatchParams) => {
  const searchParams = new URLSearchParams({
    fromDate: dispatchParams?.fromDate ?? '',
    toDate: dispatchParams?.toDate ?? '',
    project_id: dispatchParams?.projectId ?? null,
    type: Number(dispatchParams?.type) + 1 ?? null,
    reason: dispatchParams?.reason,
    cro_id: dispatchParams?.cro_id,
    oga_id: dispatchParams?.oga_id,
  });
  const res = await apiRequest({
    method: 'get',
    url: `refund-management/finance-refund-based-cards?${searchParams.toString()}`,
  });
  return res;
});
//-------------------------Refund Project Table ------------------------------------------------
export const getRefundProjectTable = createAsyncThunk('refund/getRefundProjectTable', async (dispatchParams) => {
  const searchParams = new URLSearchParams({
    fromDate: dispatchParams?.fromDate ?? '',
    toDate: dispatchParams?.toDate ?? '',
    project_id: dispatchParams?.projectId ?? '',
    type: Number(dispatchParams?.type) + 1 ?? '',
  });

  const res = await apiRequest({
    method: 'get',
    url: `refund-management/project-wise-table-data?${searchParams}`,
  });
  return res;
});
//-------------------------Refund OverView Table ------------------------------------------------
export const getRefundOverViewTable = createAsyncThunk('refund/getRefundOverViewTable', async (dispatchParams) => {
  const searchParams = new URLSearchParams({
    fromDate: dispatchParams?.fromDate ?? '',
    toDate: dispatchParams?.toDate ?? '',
    type: Number(dispatchParams?.type) + 1 ?? '',
    financeStatus: dispatchParams?.financeStatus ?? '',
  });
  const res = await apiRequest({
    method: 'get',
    url: `refund-management/reason-overview-data?${searchParams}`,
  });
  return res;
});

export const getCroOgaUnderProjectInRefundRequests = createAsyncThunk(
  'refund/getCroOgaUnderProjectInRefundRequests',
  async (id) => {
    const res = await apiRequest({
      method: 'get',
      url: `refund-management/get-oga-under-project?project_id=${id}`,
    });
    return res;
  },
);

//-------------------------Refund Rolse Wise Table ------------------------------------------------
export const getRefundRoleWiseTable = createAsyncThunk('refund/getRefundRoleWiseTable', async (dispatchParams) => {
  const searchParams = new URLSearchParams({
    fromDate: dispatchParams?.fromDate ?? '',
    toDate: dispatchParams?.toDate ?? '',
    type: Number(dispatchParams?.type) + 1 ?? '',
    role: dispatchParams?.role ?? '',
    page: dispatchParams?.page ?? 1,
    limit: dispatchParams?.limit ?? 10,
    search: dispatchParams?.search ?? '',
    financeStatus: dispatchParams?.financeStatus ?? '',
  });

  const res = await apiRequest({
    method: 'get',
    url: `refund-management/role-based-data?${searchParams}`,
  });
  return res;
});

//-------------------------CHECKING PM REFUND APPROVAL PENDING COUNT ------------------------------------------------
export const getPmRefundApprovalPendingCount = createAsyncThunk('refund/getPmRefundApprovalPendingCount', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `refund-management/get-pm-pending-count`,
  });
  return res;
});

//-------------------------Refund re-request toggle per row (Finance) ----------------------
export const updateReRequestStatus = createAsyncThunk('finance/updateReRequestStatus', async (data) => {
  const res = await apiRequest({
    method: 'put',
    url: `refund-management/update-re-request-status`,
    data,
  });
  return res;
});

//-------------------------Re request COUNT ------------------------------------------------
export const getRerequestRaisedCount = createAsyncThunk(
  'finance/getRerequestRaisedCount',
  async ({
    pageNum = 1,
    gridSize = 10,
    search = '',
    status = '',
    fromDate = '',
    toDate = '',
    statusBy,
    statusType,
  }) => {
    const searchParams = new URLSearchParams({
      page: pageNum,
      limit: gridSize,
      search,
      status,
      fromDate,
      toDate,
      ...(statusBy !== undefined && { statusBy }),
      ...(statusType !== undefined && { statusType }),
    });
    const res = await apiRequest({
      method: 'get',
      url: `refund-management/get-raise-request-rejected-datas?${searchParams.toString()}`,
    });

    return res;
  },
);

export const getDuplicateRefundRequestFinance = createAsyncThunk(
  'finance/getDuplicateRefundRequestFinance',
  async (dispatchParams) => {
    const searchParams = new URLSearchParams({
      page: dispatchParams.page,
      limit: dispatchParams.limit,
      search: dispatchParams.search || '',
      fromDate: dispatchParams.fromDate,
      toDate: dispatchParams.toDate,
      statusBy: dispatchParams.statusBy,
      statusType: dispatchParams.statusType,
    });

    const res = await apiRequest({
      method: 'get',
      url: `refund-management/get-duplicate-request-for-finance?${searchParams.toString()}`,
    });

    return res;
  },
);

// refund bank details - edit
export const editRefundBankDetails = createAsyncThunk('finance/editRefundBankDetails', async (data) => {
  const res = await apiRequest({
    method: 'put',
    url: `/refund-management/edit-refund-data-by-finance`,
    data,
  });
  return res;
});

const refundSlice = createSlice({
  name: 'refund',
  initialState,

  reducers: {
    clearStudentData: (state, action) => {
      state.studentData = {};
    },
    clearLeadData: (state, action) => {
      state.leadData = {};
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAddedRequests.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAddedRequests.fulfilled, (state, action) => {
      const data = action.payload;
      return {
        ...state,
        refundrequests: data,
        loading: false,
      };
    });
    builder.addCase(addRefundRequest.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(addRefundRequest.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // ----------------------------- GET STUDENTS --------------------------------
    builder.addCase(getStudents.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getStudents.fulfilled, (state, action) => {
      const data = Array.isArray(action.payload?.data) ? action.payload.data : [];

      return {
        ...state,
        stundentslist: data,
        loading: false,
      };
    });
    // ------------------------ GET STUDENT DETAILS -----------------------------------
    builder.addCase(getLeadListForOtherIncome.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getLeadListForOtherIncome.fulfilled, (state, action) => {
      const data = Array.isArray(action.payload?.data) ? action.payload.data : [];
      return {
        ...state,
        // leadList: data,
        stundentslist: data,
        loading: false,
      };
    });
    // ----------------------------- GET PROJECTS --------------------------------
    builder.addCase(getProjects.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getProjects.fulfilled, (state, action) => {
      const data = Array.isArray(action.payload?.data?.projects) ? action.payload.data.projects : [];
      return {
        ...state,
        projectslist: [{ id: 0, name: 'All' }, ...data],
        loading: false,
      };
    });
    // ----------------------------- GET CRO LIST --------------------------------
    builder.addCase(getAllCroList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllCroList.fulfilled, (state, action) => {
      const data = action.payload.data;
      return {
        ...state,
        crolist: data,
        loading: false,
      };
    });
    // ------------------- GET ACTIVE COURSES ---------------------------
    builder.addCase(getCoursesUndeAdmnNo.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCoursesUndeAdmnNo.fulfilled, (state, action) => {
      const data = Array.isArray(action.payload?.data) ? action.payload.data : [];

      return {
        ...state,
        allcourses: data,
        loading: false,
      };
    });
    // ------------------- GET LEAD COURSES ---------------------------
    builder.addCase(getCoursesUnderLeadId.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCoursesUnderLeadId.fulfilled, (state, action) => {
      const data = Array.isArray(action.payload?.data) ? action.payload.data : [];

      return {
        ...state,
        allcourses: data,
        loading: false,
      };
    });
    // ------------------------ GET SUBJECTS -----------------------------------
    builder.addCase(getSubjectUnderCourseEnrolmentid.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSubjectUnderCourseEnrolmentid.fulfilled, (state, action) => {
      const data = Array.isArray(action.payload.data) ? action.payload.data : [];
      return {
        ...state,
        subjects: data,
        loading: false,
      };
    });
    // ------------------------ GET STUDENT DETAILS -----------------------------------
    builder.addCase(getStudentDetails.pending, (state) => {
      state.loading = true;
      state.additionalLoading = true;
    });
    builder.addCase(getStudentDetails.fulfilled, (state, action) => {
      return {
        ...state,
        studentData: action.payload.data,
        loading: false,
        additionalLoading: false,
      };
    });

    // ------------------------ GET LEAD DETAILS -----------------------------------
    builder.addCase(getLeadDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getLeadDetails.fulfilled, (state, action) => {
      return {
        ...state,
        leadData: action.payload.data,
        loading: false,
      };
    });
    // ------------------------ GET REFUND CALUCULATION DETAILS -----------------------------------
    builder.addCase(getRefundCalculation.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getRefundCalculation.fulfilled, (state, action) => {
      const data = action.payload.data;
      return {
        ...state,
        refundCalculation: data,
        loading: false,
      };
    });
    // -----------------------getEnrolledRequest----------------------------------
    builder.addCase(getEnrolledRefundRequest.pending, (state, action) => {
      state.loading = true;
    });

    builder.addCase(getEnrolledRefundRequest.fulfilled, (state, action) => {
      state.loading = false;
      state.refundRequestTable.data = action.payload.data;

      state.refundRequestTable.meta = action.payload.meta;
    });
    // finance
    builder.addCase(getEnrolledRefundRequestFinance.pending, (state, action) => {
      state.loading = true;
    });

    builder.addCase(getEnrolledRefundRequestFinance.fulfilled, (state, action) => {
      state.loading = false;
      state.refundRequestTable.data = action.payload.data;

      state.refundRequestTable.meta = action.payload.meta;
    });
    // -----------------------getNonEnrolledRequest----------------------------------
    builder.addCase(getNonEnrolledRefundRequest.pending, (state, action) => {
      state.loading = true;
    });

    builder.addCase(getNonEnrolledRefundRequest.fulfilled, (state, action) => {
      state.loading = false;
      state.refundRequestTable.data = action.payload.data;

      state.refundRequestTable.meta = action.payload.meta;
    });
    // --------------------------- getTutorsTable
    builder.addCase(getTutorsTable.pending, (state) => {
      state.refundTutorsTable.loading = true;
    });
    builder.addCase(getTutorsTable.fulfilled, (state, action) => {
      state.refundTutorsTable.loading = false;
      state.refundTutorsTable.data = action.payload.data;
    });
    // -----------------------getEnrolledRequest FOR APPROVAL----------------------------------
    builder.addCase(getApprovalRequests.pending, (state, action) => {
      state.loading = true;
    });

    builder.addCase(getApprovalRequests.fulfilled, (state, action) => {
      state.loading = false;
      state.refundApprovalsData.data = Array.isArray(action.payload.data) ? action.payload.data : [];

      state.refundApprovalsData.meta = action.payload.meta;
    });
    // -----------------------getEnrolledRequest FOR VERIFICATION----------------------------------
    builder.addCase(getVerificationRequests.pending, (state, action) => {
      state.loading = true;
    });

    builder.addCase(getVerificationRequests.fulfilled, (state, action) => {
      state.loading = false;
      state.refundApprovalsData.data = Array.isArray(action.payload.data) ? action.payload.data : [];

      state.refundApprovalsData.meta = action.payload.meta;
    });

    //-------------------- change status
    builder.addCase(postChangeStatus.pending, (state) => {
      state.submitionLoading = true;
    });
    builder.addCase(postChangeStatus.fulfilled, (state) => {
      state.submitionLoading = false;
    });

    //-------------------- enrolled scheduled date for finance
    builder.addCase(postEnrolledScheduleDateFinance.pending, (state) => {
      state.submitionLoading = true;
    });
    builder.addCase(postEnrolledScheduleDateFinance.fulfilled, (state) => {
      state.submitionLoading = false;
    });
    //-------------------- Non enrolled scheduled date for finance
    builder.addCase(postNonEnrolledScheduleDateFinance.pending, (state) => {
      state.submitionLoading = true;
    });
    builder.addCase(postNonEnrolledScheduleDateFinance.fulfilled, (state) => {
      state.submitionLoading = false;
    });
    //-------------------- put BankDetails
    builder.addCase(putBankDetails.pending, (state) => {
      state.submitionLoading = true;
    });
    builder.addCase(putBankDetails.fulfilled, (state) => {
      state.submitionLoading = false;
    });
    // -----------------------getEnrolledRequest FOR PM VIEW----------------------------------
    builder.addCase(getPmRefundRequests.pending, (state, action) => {
      state.loading = true;
    });

    builder.addCase(getPmRefundRequests.fulfilled, (state, action) => {
      state.loading = false;
      state.refundRequestPmData.data = Array.isArray(action.payload.data) ? action.payload.data : [];

      state.refundRequestPmData.meta = action.payload.meta;
    });
    // -----------------------SHCEDULE  FOR NON ENROLLED----------------------------------
    builder.addCase(getSchedulePaymentsForNonEnrolledStudents.pending, (state, action) => {
      state.loading = true;
    });

    builder.addCase(getSchedulePaymentsForNonEnrolledStudents.fulfilled, (state, action) => {
      state.loading = false;
      state.scheduledPayments.data = Array.isArray(action.payload.data) ? action.payload.data : [];

      state.scheduledPayments.meta = action.payload.meta;
    });
    // -----------------------SHCEDULE  FOR  ENROLLED----------------------------------
    builder.addCase(getSchedulePaymentsForEnrolledStudents.pending, (state, action) => {
      state.loading = true;
    });

    builder.addCase(getSchedulePaymentsForEnrolledStudents.fulfilled, (state, action) => {
      state.loading = false;
      state.scheduledPayments.data = Array.isArray(action.payload.data) ? action.payload.data : [];

      state.scheduledPayments.meta = action.payload.meta;
    });
    //------------------------deleteRequest------------------------------------
    builder.addCase(deleteRequest.pending, (state) => {
      state.submitionLoading = true;
    });
    builder.addCase(deleteRequest.fulfilled, (state) => {
      state.submitionLoading = false;
    });
    //------------------------ mark as paid -------------------------
    builder.addCase(postMarkAsPaid.pending, (state) => {
      state.submitionLoading = true;
    });
    builder.addCase(postMarkAsPaid.fulfilled, (state) => {
      state.submitionLoading = false;
    });
    //------------------------updater transaction date------------------------------------
    builder.addCase(updateTransactionDate.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateTransactionDate.fulfilled, (state) => {
      state.loading = false;
    });
    // -----------------------DEDUCTION  FOR ENROLLED----------------------------------
    builder.addCase(getDeductionTableForEnrollment.pending, (state, action) => {
      state.loading = true;
    });

    builder.addCase(getDeductionTableForEnrollment.fulfilled, (state, action) => {
      state.loading = false;
      state.deductionTable.data = Array.isArray(action.payload.data) ? action.payload.data : [];

      state.deductionTable.meta = action.payload.meta;
    });
    //------------------------deduction for non enrolled------------------------------------
    builder.addCase(getDeductionTableForNonEnrollment.pending, (state, action) => {
      state.loading = true;
    });

    builder.addCase(getDeductionTableForNonEnrollment.fulfilled, (state, action) => {
      state.loading = false;
      state.deductionTable.data = Array.isArray(action.payload.data) ? action.payload.data : [];
      state.deductionTable.meta = action.payload.meta;
    });
    //------------------------REFUND TRACK non enrolled------------------------------------
    builder.addCase(getRefundTrack.pending, (state, action) => {
      state.loading = true;
    });

    builder.addCase(getRefundTrack.fulfilled, (state, action) => {
      state.loading = false;
      state.refundTrack = Array.isArray(action.payload.data) ? action.payload.data : [];
    });
    //------------------------DASH BOARD TOP SECTION-----------------------------------
    builder.addCase(topCardCounts.pending, (state, action) => {
      state.topsectionDashboard.topsectionDashboardLoading = true;
    });

    builder.addCase(topCardCounts.fulfilled, (state, action) => {
      state.topsectionDashboard.topsectionDashboardLoading = false;
      state.topsectionDashboard.data = action.payload.data;
    });
    //SECOND CARD SECTIONS
    builder.addCase(secondCardCounts.pending, (state, action) => {
      state.secondCardCounts.secondCardCountsLoading = true;
    });

    builder.addCase(secondCardCounts.fulfilled, (state, action) => {
      state.secondCardCounts.secondCardCountsLoading = false;
      state.secondCardCounts.data = action.payload.data;
    });
    //---------------------- Project Table
    builder.addCase(getRefundProjectTable.pending, (state, action) => {
      state.refundProjectTable.projectTableLoading = true;
    });

    builder.addCase(getRefundProjectTable.fulfilled, (state, action) => {
      state.refundProjectTable.projectTableLoading = false;
      state.refundProjectTable.data = action.payload.data;
    });
    //---------------------- OverView Table
    builder.addCase(getRefundOverViewTable.pending, (state, action) => {
      state.refundOverviewTable.refundOverviewLoading = true;
    });

    builder.addCase(getRefundOverViewTable.fulfilled, (state, action) => {
      state.refundOverviewTable.refundOverviewLoading = false;
      state.refundOverviewTable.data = action.payload.data;
    });
    //---------------------- CRO AND OGA LISTS
    builder.addCase(getCroOgaUnderProjectInRefundRequests.pending, (state, action) => {
      state.croAndOgaRefundList.croAndOgaLoading = true;
    });

    builder.addCase(getCroOgaUnderProjectInRefundRequests.fulfilled, (state, action) => {
      state.croAndOgaRefundList.croAndOgaLoading = false;
      state.croAndOgaRefundList.cro = action.payload?.data?.cro;
      state.croAndOgaRefundList.oga = action.payload?.data?.oga;
    });
    //-------------------------Refund Rolse Wise Table ------------------------------------------------
    builder.addCase(getRefundRoleWiseTable.pending, (state, action) => {
      state.refundRoleWiseTable.refundRoleWiseLoading = true;
    });

    builder.addCase(getRefundRoleWiseTable.fulfilled, (state, action) => {
      state.refundRoleWiseTable.refundRoleWiseLoading = false;
      state.refundRoleWiseTable.data = action.payload.data;
      state.refundRoleWiseTable.meta = action.payload.meta;
    });
    //-------------------------CHECKING PM REFUND APPROVAL PENDING COUNT ------------------------------------------------
    builder.addCase(getPmRefundApprovalPendingCount.pending, (state, action) => {
      state.loading = true;
    });

    builder.addCase(getPmRefundApprovalPendingCount.fulfilled, (state, action) => {
      state.loading = false;
      const pm_pending_count = action.payload?.data?.pm_pending_count || 0;
      state.pmPendingCount = pm_pending_count;
      const existingCounts = JSON.parse(localStorage.getItem('refundPendingCounts')) || {};
      const refundPendingCounts = {
        ...existingCounts,
        PM: pm_pending_count,
      };
      localStorage.setItem('refundPendingCounts', JSON.stringify(refundPendingCounts));
    });
    //-------------------------Re request COUNT ------------------------------------------------
    builder.addCase(getRerequestRaisedCount.pending, (state, action) => {
      state.loading = true;
    });

    builder.addCase(getRerequestRaisedCount.fulfilled, (state, action) => {
      state.loading = false;
      state.rerequestRaisedCount.data = action.payload?.data;
      state.rerequestRaisedCount.meta = action.payload?.meta;
    });

    //get duplicate refund request for finance
    builder.addCase(getDuplicateRefundRequestFinance.pending, (state) => {
      state.duplicateRefundRequestFinance.duplicateRefundRequestFinanceLoading = true;
    });

    builder.addCase(getDuplicateRefundRequestFinance.fulfilled, (state, action) => {
      state.duplicateRefundRequestFinance.duplicateRefundRequestFinanceLoading = false;
      state.duplicateRefundRequestFinance.data = action.payload?.data || [];
      state.duplicateRefundRequestFinance.meta = action.payload?.meta || {};
    });

    builder.addCase(getDuplicateRefundRequestFinance.rejected, (state) => {
      state.duplicateRefundRequestFinance.duplicateRefundRequestFinanceLoading = false;
    });

    // edit refund bank details
    builder.addCase(editRefundBankDetails.pending, (state) => {
      state.submitionLoading = true;
    });
    builder.addCase(editRefundBankDetails.fulfilled, (state) => {
      state.submitionLoading = false;
    });
  },
});

export const { clearStudentData, clearLeadData } = refundSlice.actions;

export default refundSlice.reducer;
